import { _c } from "../../../../services/text-services";
import Modal, { ModalProps } from "../../../shared/modal/modal.component";
// @ts-ignore
import styles from "./login2.component.module.scss";
import AppLogin2 from "./login2.component";
import Modal2 from "../../../shared/modal2/modal2.component";
import { useContext } from "react";
import AppContext from "../../../../services/app-context-services";
import { useRouter } from "next/router";

function AppLoginPopup2({ onClose }: ModalProps) {
  const appCtx = useContext(AppContext);
  const { referrer, setReferrer, profile } = appCtx;
  const router = useRouter();

  return (
    <Modal2 onClose={() => onClose()} hasCloseBtn>
      <div className={_c(styles, "modal")}>
        <AppLogin2
          container="modal"
          onLoginComplete={() =>
            referrer &&
            profile?.active_subs &&
            profile.active_subs.length === 0
              ? router.push(referrer).then(() => {
                  setReferrer("");
                  onClose();
                })
              : window.location.reload()
          }
        />
      </div>
    </Modal2>
  );
}

export default AppLoginPopup2;
